class fullChartDates { 
    constructor(options) {
        this.workingDayStart = 8;
        this.datetime = {
            lang: 'en',
            format: { 
                day: 'numeric' 
            }
        };

        const dayFrom = this.prepareDay(new Date(options.dayFrom)); 
        const dayTill =  this.prepareDay(new Date(options.dayTill)); 
        
        const timeA = this.getTime(dayFrom);
        const timeB = this.getTime(dayTill);
        
        const offset = this.getDaysOffset(timeA, timeB); 
        this.days = this.getDays(dayFrom, offset); 
        console.log(dayFrom, offset);
        
    }

    getTime(day) {
        return day.getTime();
    } 

    setHours(day) {
        day.setHours(this.workingDayStart);
    }

    prepareDay(day) { 
        this.setHours(day);
        
        return day;
    }

    getDaysOffset(timeA, timeB) {
        const diff = timeB - timeA;
        const oneDay = 1000 * 60 * 60 * 24;
        
        return Math.ceil(diff / oneDay);
    }
 
    getDays(dayFrom, offset) {
        const result = [];
    
        for (let i = 0; i <= offset; i++) {
            const date = new Date();
            date.setFullYear(dayFrom.getFullYear());
            date.setMonth(dayFrom.getMonth());
            date.setDate(dayFrom.getDate() + i);  

            result.push(this.format(date));
        }
        
        return result;
    }

    format(day) { 
        const format = new Intl.DateTimeFormat(this.datetime.lang, this.datetime.format) ;
        return format.format(day); 
    }
}; 

export default fullChartDates;